import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { callFetchUpload } from "../../config/api";

interface IState {
  isFetching: boolean;
  meta: {
    current: any;
    pageSize: any;
    pages: any;
    total: any;
  };
  result: any;
}

// first, create thunk
export const fetchUpload = createAsyncThunk(
  "upload/fetchUpload",
  async ({ query }: { query: string }) => {
    const response = await callFetchUpload(query);
    return response;
  }
);

const initialState: IState = {
  isFetching: true,
  meta: {
    current: 1,
    pageSize: 10,
    pages: 0,
    total: 0,
  },
  result: [],
};

export const uploadSlice = createSlice({
  name: "upload",
  initialState,
  reducers: {
    setActiveMenu: (state, action) => {},
  },

  extraReducers: (builder) => {
    builder.addCase(fetchUpload.pending, (state, action) => {
      state.isFetching = true;
    });
    builder.addCase(fetchUpload.rejected, (state, action) => {
      state.isFetching = false;
    });
    builder.addCase(fetchUpload.fulfilled, (state, action: any) => {
      if (action.payload && action.payload.data) {
        state.isFetching = false;
        state.meta = action.payload.data.meta;
        state.result = action.payload.data.result;
      }
    });
  },
});

export const { setActiveMenu } = uploadSlice.actions;

export default uploadSlice.reducer;
